/** @jsxImportSource @emotion/react */
import * as React from 'react';
import { connect } from 'react-redux';
import { IAppState } from '../core/redux/IAppState';
import { css } from '@emotion/react';
import { LIGHT_GREY } from '../styles/colors';
import comment from '../assets/icons/comment.svg';


/**
 * Test Page, an empty page for devs to test random stuff on
 */
export default connect(
// Map state to props
(state: IAppState, props) => ({}),
// Map dispatch to props
)(class TestingPage extends React.PureComponent<{}, {}> {
  public state = {};


  public render = () => <div css={css`
                               height: 100%;
                               display: flex;
                               flex-direction: column;
                               justify-content: center;
                               align-items: center;
                             `}>
    <span css={css`font-size: 20px;`}>Test content here</span>
    <div css={css`
               display: flex;
               flex-direction: row;
               align-items: center;
               background-color: ${LIGHT_GREY};
               border-radius: 60px;
               padding: 10px;
             `}>
      <img src={comment} css={css`margin-right: 10px;`} alt=''/>
      <img src={comment} alt=''/>s
    </div>
  </div>;
});
